export default [
    {
        name: 'home-buying.index',
        path: '/home-buying',
        component: () => import('@/views/home-buying/index.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.getting-started',
        path: '/home-buying/getting-started',
        component: () => import('@/views/home-buying/getting-started.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.get-prequalified',
        path: '/home-buying/get-prequalified',
        component: () => import('@/views/home-buying/get-prequalified.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.making-offers',
        path: '/home-buying/making-offers',
        component: () => import('@/views/home-buying/get-prequalified.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.signed-agreement',
        path: '/home-buying/signed-agreement',
        component: () => import('@/views/home-buying/get-prequalified.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.connected-with-ae',
        path: '/home-buying/connected-with-ae',
        component: () => import('@/views/home-buying/connected-with-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.who-is-ae',
        path: '/home-buying/who-is-ae',
        component: () => import('@/views/home-buying/who-is-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.found-home',
        path: '/home-buying/found-home',
        component: () => import('@/views/home-buying/found-home.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.home-location',
        path: '/home-buying/home-location',
        component: () => import('@/views/home-buying/home-location.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.where-to-buy',
        path: '/home-buying/where-to-buy',
        component: () => import('@/views/home-buying/where-to-buy.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.what-type-home-is',
        path: '/home-buying/what-type-home-is',
        component: () => import('@/views/home-buying/what-type-home-is.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.how-plan-to-use-it',
        path: '/home-buying/how-plan-to-use-it',
        component: () => import('@/views/home-buying/how-plan-to-use-it.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.picked-home-price',
        path: '/home-buying/picked-home-price',
        component: () => import('@/views/home-buying/picked-home-price.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.first-time-homebuyer',
        path: '/home-buying/first-time-homebuyer',
        component: () => import('@/views/home-buying/first-time-homebuyer.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.estimated-down-payment',
        path: '/home-buying/estimated-down-payment',
        component: () => import('@/views/home-buying/estimated-down-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.down-payment-assistance',
        path: '/home-buying/down-payment-assistance',
        component: () => import('@/views/home-buying/down-payment-assistance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.working-with-real-estate-agent',
        path: '/home-buying/working-with-real-estate-agent',
        component: () => import('@/views/home-buying/working-with-real-estate-agent.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.agent-contact-info',
        path: '/home-buying/agent-contact-info',
        component: () => import('@/views/home-buying/agent-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.own-or-rent',
        path: '/home-buying/own-or-rent',
        component: () => import('@/views/home-buying/own-or-rent.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.your-current-address',
        path: '/home-buying/your-current-address',
        component: () => import('@/views/home-buying/your-current-address.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.plan-to-sell',
        path: '/home-buying/plan-to-sell',
        component: () => import('@/views/home-buying/plan-to-sell.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.estimated-selling-price',
        path: '/home-buying/estimated-selling-price',
        component: () => import('@/views/home-buying/estimated-selling-price.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.current-mortgage-balance',
        path: '/home-buying/current-mortgage-balance',
        component: () => import('@/views/home-buying/current-mortgage-balance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.selling-with-guidance',
        path: '/home-buying/selling-with-guidance',
        component: () => import('@/views/home-buying/selling-with-guidance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.personal-info',
        path: '/home-buying/personal-info',
        component: () => import('@/views/home-buying/personal-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.your-info',
        path: '/home-buying/your-info',
        component: () => import('@/views/home-buying/your-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.co-applicant',
        path: '/home-buying/co-applicant',
        component: () => import('@/views/home-buying/co-applicant.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.coapplicant',
        path: '/home-buying/coapplicant',
        component: () => import('@/views/home-buying/coapplicant.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.coapplicant-contact-info',
        path: '/home-buying/coapplicant-contact-info',
        component: () => import('@/views/home-buying/coapplicant-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.your-credit-score',
        path: '/home-buying/your-credit-score',
        component: () => import('@/views/home-buying/your-credit-score.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.employment-status',
        path: '/home-buying/employment-status',
        component: () => import('@/views/home-buying/employment-status.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.bankruptcy',
        path: '/home-buying/bankruptcy',
        component: () => import('@/views/home-buying/bankruptcy.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.finances',
        path: '/home-buying/finances',
        component: () => import('@/views/home-buying/finances.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.yearly-income',
        path: '/home-buying/yearly-income',
        component: () => import('@/views/home-buying/yearly-income.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.coapplicant-annual-income',
        path: '/home-buying/coapplicant-annual-income',
        component: () => import('@/views/home-buying/coapplicant-annual-income.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.list-your-expenses',
        path: '/home-buying/list-your-expenses',
        component: () => import('@/views/home-buying/list-your-expenses.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.create-account',
        path: '/home-buying/create-account',
        component: () => import('@/views/auth/create-account.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.new-account',
        path: '/home-buying/new-account',
        component: () => import('@/views/auth/new-account.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.pre-approval',
        path: '/home-buying/pre-approval',
        component: () => import('@/views/home-buying/pre-approval.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.skipped',
        path: '/home-buying/skipped',
        component: () => import('@/views/home-buying/skipped.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.need-more-info',
        path: '/home-buying/need-more-info',
        component: () => import('@/views/home-buying/need-more-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.success',
        path: '/home-buying/success',
        component: () => import('@/views/home-buying/success.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.success-no-ae',
        path: '/home-buying/success-no-ae',
        component: () => import('@/views/home-buying/success-no-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.starting-price',
        path: '/home-buying/starting-price',
        component: () => import('@/views/home-buying/starting-price.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.buying-with-guidance',
        path: '/home-buying/buying-with-guidance',
        component: () => import('@/views/home-buying/buying-with-guidance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.monthly-rental-payment',
        path: '/home-buying/monthly-rental-payment',
        component: () => import('@/views/home-buying/monthly-rental-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.monthly-mortgage-payment',
        path: '/home-buying/monthly-mortgage-payment',
        component: () => import('@/views/home-buying/monthly-mortgage-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.property-taxes',
        path: '/home-buying/property-taxes',
        component: () => import('@/views/home-buying/property-taxes.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.seller-concessions',
        path: '/home-buying/seller-concessions',
        component: () => import('@/views/home-buying/seller-concessions.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.earnest-money-deposit',
        path: '/home-buying/earnest-money-deposit',
        component: () => import('@/views/home-buying/earnest-money-deposit.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.expected-closing-date',
        path: '/home-buying/expected-closing-date',
        component: () => import('@/views/home-buying/expected-closing-date.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },

    {
        name: 'home-buying.local-storage',
        path: '/home-buying/local-storage',
        component: () => import('@/views/home-buying/local-storage.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buying.pq-letter',
        path: '/home-buying/pq-letter',
        component: () => import('@/views/home-buying/pq-letter.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    }
];
